import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect } from 'react';
import { useCallbacks } from './callbackProvider';
import { logStore } from '../stores/logStore';
const LogContext = createContext(null);
export const ErrorProvider = ({ children }) => {
    const callbacks = useCallbacks();
    useEffect(() => {
        if (callbacks?.onError) {
            logStore.getState().setLogger(callbacks.onError);
        }
    }, [callbacks.onError]);
    return _jsx(LogContext.Provider, { value: null, children: children });
};
